import type { IAttributes, IAugmentedJQuery, IDirectiveCompileFn, IDirectiveLinkFn } from "angular";
import { forEach } from "angular";

export class InputDirectiveFunctions {
    public static compile(linkFunction?: IDirectiveLinkFn): IDirectiveCompileFn {
        // eslint-disable-next-line func-names
        return function (templateElement: IAugmentedJQuery, templateAttributes: IAttributes) {
            const attributes = templateAttributes.$attr as any;
            const inputElem = templateElement.children("input, select, textarea, ui-select").eq(0);

            // if no name set calc one
            if (!attributes.name) {
                const lastPartOfName = templateAttributes.ngModel.substring(
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    templateAttributes.ngModel.lastIndexOf(".") + 1,
                );
                inputElem.attr("name", lastPartOfName);
            } else {
                inputElem.attr("name", templateAttributes.name);
            }

            if (attributes.irOptions && inputElem.is("select")) {
                inputElem.attr("ng-options", templateAttributes.irOptions);
            }

            const attrsToIgnore = [
                "ir-label",
                "name",
                "ng-model",
                "ir-options",
                "date-min",
                "date-max",
                "date-future",
                "inclusive",
                "ignore-time",
                "uib-tooltip",
                "tooltip-append-to-body",
            ];

            forEach(attributes, (attr, key) => {
                if (!attrsToIgnore.includes(attr)) {
                    inputElem.attr(attr, templateAttributes[key]);
                    templateElement.removeAttr(attr);
                }
            });
            return linkFunction;
        };
    }

    public static link(
        scope: any, // Since we are handling non-defined properties in a dynamic way
        /* eslint-disable @typescript-eslint/no-unused-vars */
        instanceElement: JQuery,
        instanceAttributes: IAttributes,
        controller?: any,
        transclude?: any,
        /* eslint-enable @typescript-eslint/no-unused-vars */
    ) {
        if (!scope.$ctrl) {
            if (scope.$parent && scope.$parent.$ctrl) {
                scope.$ctrl = scope.$parent.$ctrl;
            } else if (scope.$parent && scope.$parent.$parent && scope.$parent.$parent.$ctrl) {
                scope.$ctrl = scope.$parent.$parent.$ctrl;
            } else {
                // eslint-disable-next-line
                console.warn("Could not find any $ctrl", scope);
            }
        }
    }
}
